var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sign-out-view view"})
}
var staticRenderFns = []

export { render, staticRenderFns }